import {ActionTree, ActionContext} from 'vuex'
import {IAuthentificationStateModel, IRootStateModel} from '../../../interfaces'
import { AuthentificationMutations } from './../mutations'
import { ActionTypes } from './types'
import { MutationTypes } from './../mutations/types'
import {LoginWithPasswordRequestModel, LoginWithPasswordResponseModel, Profile} from './../../../../services/types'
import {getClient, createClientInstance} from '../../../../services/client/clientProvider'
import { BaseClient } from '../../../../services/client/BaseClient'
import {Storage} from './../../../../services/storage/Storage'

type AugmentedActionAuthentificationContext = {
    commit<K extends keyof AuthentificationMutations>(
      key: K,
      payload: Parameters<AuthentificationMutations[K]>[1]
    ): ReturnType<AuthentificationMutations[K]>;
} & Omit<ActionContext<IAuthentificationStateModel, IRootStateModel>, 'commit'>

export interface AuthentificationActions {
    [ActionTypes.LOGIN_WITH_PASSWORD](context: AugmentedActionAuthentificationContext, model: LoginWithPasswordRequestModel): Promise<void>;
    [ActionTypes.LOG_OUT](context: AugmentedActionAuthentificationContext): void;
    [ActionTypes.CHECK_IS_LOGGED_IN](context: AugmentedActionAuthentificationContext): void;
}

const storage = new Storage()

const setProfileToStorage = (profile: Profile) => storage.profile.set(profile)

const getProfileFromStorage = (): Profile | null=> storage.getProfile()

export const actions: ActionTree<IAuthentificationStateModel, IRootStateModel> & AuthentificationActions = {
    async [ActionTypes.LOGIN_WITH_PASSWORD]({commit}, model: LoginWithPasswordRequestModel) {

        const client: BaseClient = getClient();

        try{
            const response: LoginWithPasswordResponseModel = await client.loginWithPassword(model)

            commit(MutationTypes.SET_AUTHENTIFICATION_PROFILE, response)
            commit(MutationTypes.SET_AUTHENTIFICATION_AUTHENTICATED, true)
            createClientInstance(response.token)
            setProfileToStorage(response)
        }
        catch(error){
            console.log('loginwithPassword', error)
            commit(MutationTypes.HAS_AUTHENTIFICATION_ERROR, true)
            
        }
        finally{
            commit(MutationTypes.SET_AUTHENTIFICATION_DATA_LOADING, false)
        }
    },
    [ActionTypes.LOG_OUT]({commit}) {
        commit(MutationTypes.SET_AUTHENTIFICATION_PROFILE, null)
        commit(MutationTypes.SET_AUTHENTIFICATION_AUTHENTICATED, false)
        storage.clear()
    },
    [ActionTypes.CHECK_IS_LOGGED_IN]({commit}) {
        const profile = getProfileFromStorage()     

        if (profile) {
            commit(MutationTypes.SET_AUTHENTIFICATION_PROFILE, profile)
            commit(MutationTypes.SET_AUTHENTIFICATION_AUTHENTICATED, true)
            createClientInstance(profile.token)
        }
        else {
            commit(MutationTypes.SET_AUTHENTIFICATION_PROFILE, null)
            commit(MutationTypes.SET_AUTHENTIFICATION_AUTHENTICATED, false)
            storage.clear()
        }
    }
}